class AudioPlayer {
  audio = new Audio()

  load (url) {
    this.audio.src = url
    this.audio.load()
    return this
  }

  play () {
    this.audio.play()
    return this
  }

  pause () {
    this.audio.pause()
    return this
  }

  reset () {
    this.audio.currentTime = 0
    return this
  }

  on (event, callback) {
    this.audio.addEventListener(event, callback)
    return this
  }

  off (event, callback) {
    this.audio.removeEventListener(event, callback)
    return this
  }
}

const audioPlayer = new AudioPlayer()
Object.freeze(audioPlayer)

export default audioPlayer
